import initialState from "./initialState";
import * as actions from "./actionTypes";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.AUTH: {
      return {
        ...state,
        auth: action.payload,
      };
    }
    case actions.SET_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }

    case actions.SET_LOGOUT_USER_ID: {
      return {
        ...state,
        logoutUserId: action.payload,
      };
    }
    case actions.REMOVE_LOGOUT_USER_ID: {
      return {
        ...state,
        logoutUserId: null,
      };
    }
    case actions.SET_VENDOR_DETAILS: {
      return {
        ...state,
        vendorDetails: action.payload,
      };
    }

    case actions.SET_VEHICLE_LIST: {
      return {
        ...state,
        vehicleList: action.payload,
      };
    }
    case actions.SET_MATERIAL_LIST: {
      return {
        ...state,
        materialList: action.payload,
      };
    }

    case actions.CLEAN_STATE: {
      return {};
    }
    case actions.LOGGED_IN: {
      return {
        ...state,
        isLoggedIn: action.payload,
      };
    }

    default: {
      return { ...state };
    }
  }
};

export default reducer;
